import React from "react";
import "./PlanBox.scss";
import CheckIcon from "../../../assets/icons/check-icon.svg";
import CloseIcon from "../../../assets/icons/not-available-icon.svg";
import dollarIcon from "../../../assets/icons/dollar-icon.svg";

interface PlanBoxProps {
  pkg: any;
  allServices: string[];
  children?: React.ReactNode; //  added
}

const PlanBox: React.FC<PlanBoxProps> = ({ pkg, allServices, children }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [showReadMore, setShowReadMore] = React.useState(false);
  const descriptionRef = React.useRef<HTMLParagraphElement>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const description = pkg.description || "";

  React.useLayoutEffect(() => {
    if (descriptionRef.current) {
      const isOverflowing = descriptionRef.current.scrollHeight > 105; // ~5 lines buffer
      setShowReadMore(isOverflowing);
    }
  }, [description]);

  const toggleReadMore = () => {
    if (isExpanded && containerRef.current) {
      // When collapsing (Read Less), scroll back to top
      containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="plan-box">
      <div className="plan-box__header">
        <h3 className="plan-box__name">{pkg.name}</h3>
        <div
          ref={containerRef}
          className={`plan-box__description-container ${isExpanded ? "plan-box__description-container--expanded" : ""
            } ${showReadMore ? "plan-box__description-container--can-expand" : ""}`}
        >
          <p ref={descriptionRef} className="plan-box__description">
            {description}
          </p>
        </div>
        {showReadMore && (
          <span
            className="plan-box__read-more"
            role="button"
            onClick={toggleReadMore}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </span>
        )}
      </div>

      <div className="plan-box__price">
        <img
          src={dollarIcon}
          alt="Dollar Icon"
          className="plan-box__dollar-icon"
        />
        {pkg.price}
      </div>

      <hr className="plan-box__divider" />

      <div className="plan-box__services">
        <p className="plan-box__services-title">Services Include</p>
        <ul className="plan-box__services-list">
          {allServices.map((service) => {
            const included = pkg.services.includes(service);
            return (
              <li
                key={service}
                className={`plan-box__service ${included
                  ? "plan-box__service--included"
                  : "plan-box__service--excluded"
                  }`}
              >
                {included ? (
                  <img
                    src={CheckIcon}
                    alt="Included"
                    className="plan-box__icon plan-box__icon--check"
                  />
                ) : (
                  <img
                    src={CloseIcon}
                    alt="Not Included"
                    className="plan-box__icon plan-box__icon--cross"
                  />
                )}
                <span className="plan-box__service-name">{service}</span>
              </li>
            );
          })}
        </ul>
      </div>

      {/*  Choose Plan button will appear INSIDE the box */}
      {children ? <div className="plan-box__choose-btn">{children}</div> : null}
    </div>
  );
};

export default PlanBox;
